import { render, staticRenderFns } from "./PDA_Handover.vue?vue&type=template&id=005d4438"
import script from "./PDA_Handover.vue?vue&type=script&lang=js"
export * from "./PDA_Handover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports